export const DAILY_REPORTS_REQUESTED = 'DAILY_REPORTS_REQUESTED';
export const DAILY_REPORTS_SUCCESS = 'DAILY_REPORTS_SUCCESS';
export const DAILY_REPORTS_FAILED = 'DAILY_REPORTS_FAILED';
